<!-- Todo: #CMS -->
<div class="w-full max-w-[636px] mt-4">
    <p class="mb-4 text-[10px] font-bold leading-4 text-[#333333]">{{ config.textHeader }}</p>
    <ul class="w-full flex flex-col gap-4 list-none">
        <li *ngFor="let option of config.paymentMethodOptions; index as i">
            <ng-container *ngIf="option.isEnabled">
                <button class="w-full flex rounded-lg p-4 bg-white border-none outline outline-1" [ngClass]="{'min-h-[84px]': option.optionType === 'bank', 'min-h-[76px]': option.optionType !== 'bank', 'outline-[#333333]': option.optionType === selectedPaymentMethod, 'outline-[#E8E8E8]': option.optionType !== selectedPaymentMethod}" (click)="selectPaymentMethod(option.optionType)">
                    <div class="grow flex">
                        <img
                        [src]="option.icon"
                        [alt]="option.iconAltText"
                        class="size-6 m-[10px] ml-2 mr-4 self-center"
                        />
                        <div class="grow flex flex-col items-start" [ngClass]="{'gap-2' : option.optionType === 'bank', 'justify-between': option.displaySubtitle, 'justify-center': !option.displaySubtitle}">
                            <!-- <div class="grow flex flex-col items-start justify-between" [ngClass]="{'gap-2' : option.optionType === 'bank'}"> -->
                            <p class="text-base font-['Roboto']">{{ labels.stellar.signIn.paymentMethods[option.title] }}</p>
                            <ng-container *ngIf="option.displaySubtitle">
                                <ng-container *ngIf="option.displayComingSoon; else subtitle">
                                    <p class="px-2 py-[4.5px] font-bold text-[10px] text-[#333333] rounded-full bg-[#E8E8E8]">{{ labels.stellar.signIn.paymentMethods.comingSoon }}</p>
                                </ng-container>
                                <ng-template #subtitle>
                                    <p class="text-xs leading-3 font-['Roboto']">{{ option.fee}} {{ labels.stellar.signIn.paymentMethods[option.subtitle] }}</p>
                                </ng-template>
                            </ng-container>
                        </div>
                        <div class="grow flex justify-end items-center">
                            <img
                            *ngIf="option.optionType === selectedPaymentMethod"
                            src="assets/images/payment-method-icons/payment-method-check-icon.svg"
                            alt="selected option checkmark icon"
                            class="size-6 m-[10px] ml-2 mr-4 self-center"
                            />
                        </div>
                    </div>
                </button>
            </ng-container>
        </li>
    </ul>
    
</div>